export const numberOnlyWithDigit = (evt, digit) => {
  const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
  if (allowedKeys.includes(evt.key)) return;
  if (!/^\d$/.test(evt.key)) {
    evt.preventDefault();
    return;
  }
  const input = evt.target;
  const value = input.value;
  // Get selected text range
  const selectionStart = input.selectionStart;
  const selectionEnd = input.selectionEnd;
  // Compute the new value length after key press
  const newLength = value.length - (selectionEnd - selectionStart) + 1;
  if (newLength > digit) {
    evt.preventDefault();
  }
};

export const autoFocusByID = (inputId, sTime) => {
    var setTime = 0;
    if(sTime) setTime = sTime;
    if (inputId) {
      window.setTimeout(function () {
        if (document.getElementById(inputId)) {
          document.getElementById(inputId).focus();
        }
      }, setTime);
    }
};

// This function the cursor will focus in first element on error input with class name 'is-invalid', When user submit the data
export const autoFocusFirstElement = (sClassName) => {
  var className = 'is-invalid';
  if(sClassName) className = sClassName;
  window.setTimeout(function () {
    const ele = document.getElementsByClassName(className);
    if(ele && ele.length > 0) {
      autoFocusByID(ele[0].id)
    }
  }, 10);
}


export const checkPasswordStrength = async (value, translate) => {
  const strength = getPasswordStrength(value);
  let {pLabel, showVarient, score} = getPasswordLabelAndVarient(value, translate)
  const pwdData = {
    strength: strength,
    label: pLabel,
    varient: showVarient,
    score: score
  }
  return pwdData
}

const MIN_PASSWORD_LENGTH = 5;

function getPasswordStrength(password) {
  let strength = 0;

  if (!password || password.length < MIN_PASSWORD_LENGTH) return strength;
  if (/[A-Z]/.test(password)) strength++;
  if (/[a-z]/.test(password)) strength++;
  if (/\d/.test(password) || /[^a-zA-Z0-9]/.test(password)) {
    if (strength > 0) {
      strength++;
    }
    strength++;
  }
  if (strength > 3 && password.length < 8) strength--;

  return strength;
}

function getPasswordLabelAndVarient(pwd, translate) {
  const score = getPasswordScore(pwd)
  let pLabel = 'none'
  let showVarient = "danger";
  switch (score) {
    case -1, 0:
      pLabel = translate('member.preregistration.strengthVeryWeak')
      showVarient = "danger";
      break;
    case 1:
      pLabel = translate('member.preregistration.strengthWeak')
      showVarient = "warning";
      break;
    case 2:
      pLabel = translate('member.preregistration.strengthAverage')
      showVarient = "warning";
      break;
    case 3:
      pLabel = translate('member.preregistration.strengthStrong')
      showVarient = "info";
      break;
    case 4:
      pLabel = translate('member.preregistration.strengthVeryStrong')
      showVarient = "success";
      break;
    case 10:
      pLabel = 'N/A'
      showVarient = "danger"
      break;
    default:
      pLabel = 'none'
  }
  return {pLabel, showVarient, score}
}

function getPasswordScore(password) {
  if (typeof password !== "string") return -1;
  const pwd = password.trim();
  const len = pwd.length;
  if (len < MIN_PASSWORD_LENGTH || !/[A-Za-z0-9]/.test(pwd)) return -1;
  if (len > 128) return 10;

  // Composition checks
  const hasLower = /[a-z]/.test(pwd);
  const hasUpper = /[A-Z]/.test(pwd);
  const hasDigit = /\d/.test(pwd);
  const hasSpecial = /[^A-Za-z0-9]/.test(pwd);
  const hasAlpha = /[A-Za-z]/.test(pwd);
  // Very strong: >= 32 and has lower + upper + digit + special
  if (len >= 32 && hasLower && hasUpper && hasDigit && hasSpecial) {
    return 4;
  }
  // Strong: >= 16 and has lower + upper + digit + special
  if (len >= 16 && hasLower && hasUpper && hasDigit && hasSpecial) {
    return 3;
  }
  // Average: >= 10 and has (alpha + digit + special)
  if (len >= 10 && hasAlpha && hasDigit && hasSpecial) {
    return 2;
  }
  // Fallback: any valid password reaching minimum requirements is weak.
  return 1;
}

export const escapeFilterCharacters = (value) => {
  return encodeURIComponent(value.replaceAll("-", "\\-").replaceAll(",", "\\,"));
}

export const validateName = (name) => {
  const allowedRegex = /^[\p{Letter}\s\-.'’`´]+$/u;
  const restrictedRegex = /[0-9@#$!;"\\\u0000-\u001F\u007F]/;
  if (restrictedRegex.test(name)) {
    return { isValid: false};
  }
  if (!allowedRegex.test(name)) {
    return { isValid: false};
  }
  return { isValid: true};
};

export const validateSpace = (e, name) => {
  if (e.key === ' ') {
    if (name.trim() === '') {
      e.preventDefault();
    } else {
      const words = name.split(' ');
      if (words[words.length - 1] === '') {
        e.preventDefault();
      }
    }
  }
};
export const validateSpaceWithEmail = (evt, name) => {
  if (evt.key === ' ') {
    const trimmedName = name.trim();
    const trimmedEmail = evt.target.value?.trim();
    if (trimmedEmail && EMAIL_REG_EX.test(trimmedEmail)) {
      evt.preventDefault();
      return;
    }
    if (trimmedName && ALIAS_REG_EX.test(trimmedName)) {
      evt.preventDefault();
      return;
    }
    const spaceCount = (name.match(/ /g) || []).length;
    if (spaceCount >= 0) {
      evt.preventDefault();
      return;
    }
    const lastChar = name[name.length - 1];
      if (lastChar === ' ') {
      evt.preventDefault();
      return;
    }
  }
}
export const preventCharactersOnPaste = (e) => {
  const paste = (e.clipboardData || window.clipboardData).getData('text');
  const cleanPaste = paste.replace(/\D/g, ''); // Keep only digits
  const currentValue = e.target.value || '';
  const totalLength = currentValue.length + cleanPaste.length;
  if (!/^\d+$/.test(paste) || totalLength > 3) {
    e.preventDefault();
  }
};

export const stripHtml = (htmlString) => {
  if (typeof htmlString !== "string") return "";
  return new DOMParser().parseFromString(htmlString, 'text/html').body.textContent.trim();
}

export const preventInvalidCharInMobile = (e) => {
    if (!/^\d$/.test(e.data)) {
      e.preventDefault();
    }
  };

export const getTranslatedDate = (sendDate, i18n) => {
  if (i18n.language === 'de') {
    const date = new Date(sendDate.split('.')[0] + 'Z');
    const datePart = date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit',});
    const timePart = date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit', hour12: false,});
    return `${datePart} ${timePart} Uhr`;
  } else {
    return new Date(sendDate?.split('.')[0] + 'Z').toLocaleString('en-US', {year: 'numeric',month: '2-digit',day: '2-digit',
      hour: '2-digit',minute: '2-digit',second: '2-digit',hour12: false
    });
    
  }
}

export function getDeviceType() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const width = window.innerWidth;
  // Basic UA-based detection
  const isTabletUA = /iPad|Tablet|Nexus 7|Nexus 10|SM-T|GT-P|Kindle|Silk/i.test(ua);
  const isMobileUA = /Mobi|Android.*Mobile|iPhone|iPod/i.test(ua);
  // Width-based fallback (if UA is unreliable)
  if (isMobileUA || width <= 767) return 'MOBILE';
  if (isTabletUA || (width > 767 && width <= 1024)) return 'TABLET';
  return 'DESKTOP';
}

export function isInvalidZip(zip) {
  if (!zip || zip.trim() === '') {
    return true; // invalid
  }
  // Regex: allows letters, digits, spaces, and hyphens only
  const regex = /^[A-Za-z0-9\s-]+$/;
  return !regex.test(zip);
}
export const preventZeroAtFirst = (value) =>{
  const strValue = String(value);
  if (strValue.startsWith('0')) return strValue.replace(/^0+/, '') || '';
  return strValue;
}
